export default __webpack_public_path__ + "a4e3f614704e49c514f8c47e12aacea8.png";